import { render, staticRenderFns } from "./MovimientosForm.vue?vue&type=template&id=87ecb776"
import script from "./MovimientosForm.vue?vue&type=script&lang=js"
export * from "./MovimientosForm.vue?vue&type=script&lang=js"
import style0 from "./MovimientosForm.vue?vue&type=style&index=0&id=87ecb776&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports